const GTM_CUSTOM_EVENTS = {
  LOGIN: "login",
  SINGUP: "signup",
  TEMPLATE_CREATED: "template_created",
  TEMPLATE_CLONED: "template_cloned",
  TEMPLATE_PUBLISHED: "template_published",
  TEMPLATE_EDITED: "template_edited",
  DOCUMENT_CREATED: "doc_created",
  TEMPLATE_DEACTIVATED: "template_deactivated",
  TEMPLATE_JSON_DOWNLOAD: "template_json_download",
  DOC_UPLOADED: "doc_uploaded",
  DOC_DOWNLOADED: "doc_downloaded",
  DOC_DELETED: "doc_deleted",
  SAVED_AS_TEMPLATE: "saved_as_template",
  MAGIC_LINK_GENERATED: "magic_link_generated",
  SNAP_LINK_GENERATED: "snap_link_generated",
  DOC_SENT_FOR_ESGIN: "doc_sent_for_esign",
  DOC_SENT_FOR_REVIEW: "doc_sent_via_email",
  DOC_SENT_FOR_PAYMENT: "doc_sent_for_payment",
  DOC_SENT_FOR_ACCEPTANCE: "doc_sent_for_acceptance",
  DOC_SENT_FOR_APPROVAL: "doc_sent_for_approval",
  FORM_FIELD_FILLED: "form_field_filled",
  USER_INVITED: "user_invited",
  SUBSCRIBE_SUCCESS: "subscribe_success",
  SUBSCRIBE_FAILED: "subscribe_failed",
  TRANSACTION_SUCCESS: "transaction_success",
  TRANSACTION_FAILURE: "transaction_failed",
  DOC_SIGNED: "doc_signed",
  PAYMENT_START: "payment_start",
};

const GTM_EVENT_PARAMS = {
  FROM_TEMPLATE: "from_template",
  TEMPLATE_TITLE: "template_title",
  TEMPLATE_TYPE: "template_type",
  UPLOAD_TYPE: "upload_type",
  FILE_NAME: "file_name",
  DOC_TITLE: "doc_title",
  PLAN_NAME: "plan_name",
  PLAN_TYPE: "plan_type",
  POPUP_NAME: "popup_name",
};

export { GTM_CUSTOM_EVENTS, GTM_EVENT_PARAMS };
